// Fixed UTC dates keep weekday names independent of the device's timezone and DST.
export function getWeekdays(locale: string) {
  const short = new Intl.DateTimeFormat(locale, { weekday: 'short', timeZone: 'UTC' })
  const full = new Intl.DateTimeFormat(locale, { weekday: 'long', timeZone: 'UTC' })
  return [1, 2, 3, 4, 5, 6, 0].map((value) => {
    const date = new Date(Date.UTC(2024, 0, 7 + value))
    return { value, short: short.format(date), full: full.format(date) }
  })
}
